import { DISCLOSURE_NOTES } from "@/lib/disclosures";

/**
 * The "Good to know" notes as a quiet list: one small gold-framed icon, a
 * one-line heading and a sentence or two each. One column on phones, two
 * balanced columns from the sm breakpoint up.
 */
export default function DisclosureNotes({ className = "" }: { className?: string }) {
  return (
    <ul className={`space-y-3 text-left sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-5 sm:space-y-0 ${className}`}>
      {DISCLOSURE_NOTES.map(({ Icon, heading, body }) => (
        <li key={heading} className="flex items-start gap-3">
          <span
            aria-hidden="true"
            className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-sm border border-primary/25 bg-primary/10 text-primary"
          >
            <Icon className="h-3.5 w-3.5" />
          </span>
          <div className="min-w-0">
            <p className="font-display text-[13px] leading-snug tracking-wide text-foreground/90">{heading}</p>
            <p className="mt-0.5 font-body text-sm leading-relaxed text-muted-foreground">{body}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
